export {ContentManagerComponent} from './content-manager.component';
